<page-top-menu [name]="name"></page-top-menu>
<div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
        <div id="sew_principal">
            <div class="row">

                <div class="alert alert-success" role="alert" style=" text-align: justify;" hidden="hidden">
                    <p>
                        Estimado Contribuyente: Todo documento para ingresar a la Direcci&oacute;n de Obras Municipales a trav&eacute;s de este medio, como requisito debe venir
                        <b>
					con un espacio libre de 20x10 cent&iacute;metros en la esquina inferior izquierda para la FIRMA DIGITAL cuando corresponda.
					</b>
                    </p>
                </div>
                <div class="col-md-6" id="col-btn">
                    <a id="btn-xlarge" class="btn-xl faa-parent animated-hover" role="button" href="index.php?p=tramites">
                        <i class="fa fa-file-text faa-tada"></i> Nueva Solicitud
                    </a>
                </div>
                <div class="col-md-6" id="col-btn">
                    <a id="btn-xlarge" class="btn-xl faa-parent animated-hover" role="button" href="index.php?p=tramites">
                        <i class="fa fa-indent faa-tada"></i> Seguimiento
                    </a>
                </div>

            </div>

        </div>
    </div>
    <div class="col-md-1"></div>
</div>